import { PullRequestSummary } from "./Dto";

export function getPullRequestUrl(pullRequest: PullRequestSummary): string {
  return `${pullRequest.repository.webUrl}/pullrequest/${pullRequest.pullRequestId}`;
}
